import classNames from 'classnames';
import { node, string } from 'prop-types';

import style from './ButtonPlain.module.scss';

function ButtonPlain({ children, className, ...props }) {
  return (
    <button
      className={classNames(style.plainWhiteButton, className)}
      type="button"
      {...props}
    >
      {children}
    </button>
  );
}
ButtonPlain.propTypes = {
  children: node,
  className: string,
};

export default ButtonPlain;
